import MypageOrderDetailsContainer from './MypageOrderDetailsContainer';
export default MypageOrderDetailsContainer;
